var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext } from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { MarketDetailsTab, RoutePath } from '../../app/router/config';
import updateListingIcon from '../../assets/images/icons/common/icon-edit-dark.png';
import seeIcon from '../../assets/images/icons/common/icon-reveal-full.png';
import cancelListingIcon from '../../assets/images/icons/common/icon-trash-purple.png';
import { NavHistoryContext } from '../../context/nav-history';
import { SettingsContext } from '../../context/settings';
import { useMultipleOrders } from '../../hooks/market/use-multiple-orders';
import { useMyOffers } from '../../hooks/market/use-my-offers';
import { formatDate } from '../../utils/date';
import Table, { CellAlign, CellType } from '../common/table';
import MultiSelectToolbar from '../multi-select-toolbar';
export default function OffersTable(_a) {
    var _this = this;
    var _b;
    var section = _a.section, filters = _a.filters;
    var _c = useI18n(), t = _c.t, i18n = _c.i18n;
    var showFilters = useContext(SettingsContext).showFilters;
    var items = useMyOffers(filters, section);
    var location = useLocation();
    var addHistory = useContext(NavHistoryContext).addHistory;
    var _d = useMultipleOrders(items.offers || [], function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, items.getOffers({ refresh: true })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }, {
        disabledOwned: true,
    }), selectedOrderIds = _d.selectedOrderIds, selectOrder = _d.selectOrder, shiftSelectOrder = _d.shiftSelectOrder, selectAllOrders = _d.selectAllOrders, unselectedAllOrders = _d.unselectedAllOrders, showCancelMultipleOffersDialog = _d.showCancelMultipleOffersDialog;
    function onBottomScroll() {
        items.loadMoreOffers();
    }
    var scrollRef = useBottomScrollListener(onBottomScroll);
    var labels = [
        {
            key: 'date',
            label: t('common.date'),
            align: CellAlign.LEFT,
            size: 1,
            mobileSize: 0.6,
        },
        {
            key: 'name',
            label: t('common.name'),
            align: CellAlign.LEFT,
            size: 1.5,
        },
        { key: 'price', label: t('common.offer'), align: CellAlign.RIGHT, size: 1, mobileSize: 1.2 },
        {
            key: 'action',
            label: t('common.actions'),
            align: CellAlign.CENTER,
            size: 0.5,
            mobileSize: 0.5,
            actionCell: true,
        },
    ];
    var actions = [
        {
            icon: seeIcon,
            link: {
                routePath: RoutePath.ASSET,
                generateParams: function (id) {
                    var order = items.offers && items.offers.find(function (item) { return item.order.order_id.toString() === id; });
                    return {
                        tokenId: (order === null || order === void 0 ? void 0 : order.order.buy.data.token_id) || '',
                        tab: MarketDetailsTab.ACTIVITY,
                    };
                },
            },
            action: function () { return addHistory(location); },
            alternative: true,
        },
        {
            icon: cancelListingIcon,
            action: function (id) { return items.showCancelOfferDialog(Number.parseInt(id)); },
        },
        {
            icon: updateListingIcon,
            action: function (id) { return items.showUpdateOfferDialog(Number.parseInt(id)); },
            highlighted: true,
        },
    ];
    var rows = ((_b = items.offers) === null || _b === void 0 ? void 0 : _b.map(function (offer) {
        var _a, _b, _c, _d, _e;
        return {
            id: offer.order.order_id.toString(),
            data: {
                date: {
                    type: CellType.TEXT,
                    value: formatDate(offer.order.updated_timestamp || '', i18n.language),
                },
                name: {
                    type: CellType.IMAGE_WITH_TEXT,
                    value: {
                        image: ((_a = offer.order.buy.data.properties) === null || _a === void 0 ? void 0 : _a.image_url) || '',
                        text: ((_b = offer.order.buy.data.properties) === null || _b === void 0 ? void 0 : _b.name) || '',
                    },
                },
                price: {
                    type: CellType.PRICE,
                    value: {
                        tokenSymbol: (_c = offer.price.base) === null || _c === void 0 ? void 0 : _c.symbol,
                        value: ((_d = offer.price.base) === null || _d === void 0 ? void 0 : _d.displayValue) || '0',
                        usdValue: ((_e = offer.price.usd) === null || _e === void 0 ? void 0 : _e.displayValue) || '0',
                    },
                },
            },
        };
    })) || [];
    return (_jsxs(Container, { id: "my-assets-offers-table", ref: scrollRef, showFilters: showFilters, children: [items.offers && (_jsx(Table, { actions: actions, labels: labels, notRounded: true, rows: rows, selectAllRows: selectAllOrders, selectRow: selectOrder, selectedRowIds: selectedOrderIds, shiftSelectRow: shiftSelectOrder })), _jsx(MultiSelectToolbar, { actions: [{ action: showCancelMultipleOffersDialog, text: t('common.cancel-offers'), icon: cancelListingIcon }], cancel: unselectedAllOrders, itemsCount: selectedOrderIds.length })] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 232px);\n  justify-content: flex-start;\n  overflow: auto;\n  padding: ", ";\n  transition: padding 200ms ease-in-out;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 0 0 64px 0;\n    height: auto;\n  }\n\n  & > div {\n    overflow: visible;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 232px);\n  justify-content: flex-start;\n  overflow: auto;\n  padding: ", ";\n  transition: padding 200ms ease-in-out;\n  width: 100%;\n\n  @media screen and (max-width: 824px) {\n    padding: 0 0 64px 0;\n    height: auto;\n  }\n\n  & > div {\n    overflow: visible;\n  }\n"])), function (_a) {
    var showFilters = _a.showFilters;
    return (showFilters ? '0 0 0 280px' : '0');
});
var templateObject_1;
